import { Card, Badge } from 'react-bootstrap';
import { fmtIST } from '../../utils/dateFormat';

const accent = '#cc66ff';
const cardDark = { background: 'linear-gradient(135deg, #0d0d0d 0%, #1a0033 100%)', color: '#fff', border: '1px solid #9933ff44' };

export const SlotBox = ({ node, label }) => {
  const filled = !!node;
  return (
    <div style={{
      flex: 1,
      border: `2px dashed ${filled ? accent : '#444'}`,
      borderRadius: 10,
      padding: '10px 8px',
      textAlign: 'center',
      background: filled ? '#1a003388' : '#0d0d0d55',
      minWidth: 110,
    }}>
      {filled ? (
        <div style={{ color: '#66ff99', fontWeight: 600, fontSize: 13 }}>Filled</div>
      ) : (
        <div style={{ color: '#555', fontSize: 12 }}>Waiting...</div>
      )}
    </div>
  );
};

export const ActiveNodeCard = ({ node, hideHeader = false, hideFooter = false, topStats = null }) => {
  const leftFilled = !!node.leftChildId;
  const rightFilled = !!node.rightChildId;
  const filledCount = (leftFilled ? 1 : 0) + (rightFilled ? 1 : 0);

  return (
    <Card style={{ ...cardDark, marginBottom: 16 }}>
      <Card.Body>
        {topStats}

        {!hideHeader && (
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div>
              <Badge bg="success" className="me-2">Active Node</Badge>
              {node.position && (
                <Badge style={{ background: '#9933ff' }}>
                  {node.position === 'left' ? 'Left' : 'Right'} child
                </Badge>
              )}
              {!node.parentId && <Badge style={{ background: '#cc6600' }}>Root</Badge>}
            </div>
            <div style={{ fontSize: 12, color: '#aaa' }}>
              Placed: {fmtIST(node.createdAt)}
            </div>
          </div>
        )}

        {/* Cycle visualisation */}
        <div style={{ textAlign: 'center', marginBottom: 12 }}>
          <div style={{
            display: 'inline-block',
            background: '#9933ff33',
            border: `2px solid ${accent}`,
            borderRadius: 10,
            padding: '6px 20px',
            color: accent,
            fontWeight: 700,
            fontSize: 14,
            marginBottom: 8,
          }}>
            You
          </div>
          <div style={{ color: '#555', fontSize: 20, lineHeight: 1 }}>/ \</div>
        </div>

        <div className="d-flex gap-3 justify-content-center">
          <SlotBox node={node.leftChildId} label="Left" />
          <SlotBox node={node.rightChildId} label="Right" />
        </div>

        {!hideFooter && (
          <div className="mt-3 d-flex justify-content-between align-items-center">
            <div style={{ fontSize: 12, color: '#aaa' }}>
              Slots filled: <strong style={{ color: filledCount === 2 ? '#66ff99' : accent }}>{filledCount} / 2</strong>
            </div>
            <div style={{ fontSize: 12, color: '#aaa' }}>
              20% bonus on completion: <strong style={{ color: '#66ff99' }}>
                {node.planId?.amount ? `${(node.planId.amount * 0.2).toFixed(2)} USDT` : '—'}
              </strong>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};
